import React, { Component } from 'react';
import Mapa from '../Mapas/mapa'
import firebase from 'firebase';

class MapaGlobal extends Component{
    constructor(props){
        super(props);
        this.state={
            conductores:[]
        };
    }

    componentWillMount = () =>{
        firebase.database().ref('EmpleadosGPS').on('value', snap=>{
            let conductores=[]; 
            snap.forEach(element => {    
                let data = element.val();
                if(data.estado === 'activo'){
                    conductores.push(data);
                } 
            });
            this.setState({conductores});
        })
    }

    render(){
        let {conductores} = this.state;
        return(
            <Mapa
            empleados={conductores}
            googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyCCZEbbK2GALcNzNprVpgav4lpvM4D6gGA&v=3.exp&libraries=geometry,drawing,places"
            loadingElement={<div style={{ height: `100%` }} />}
            containerElement={<div style={{ height: `400px` }} />}
            mapElement={<div style={{ height: `100%` }} />}
          />
        )
    }
}
export default MapaGlobal;


// WEBPACK FOOTER //
// ./src/Components/VistaGlobal/MapaGlobal.js